import { TOCItem } from "./generateToc";

export const BASE_TOC_TITLES = Object.freeze([
  { depth: 0, text: "Overview", id: "about" },
  { depth: 0, text: "Timeline", id: "timeline" },
  { depth: 0, text: "Purpose", id: "purpose" },
  { depth: 0, text: "Participants", id: "audience" },
  { depth: 0, text: "Prizes", id: "prizes" },
  { depth: 0, text: "Getting started", id: "getting-started" },
] as const) satisfies ReadonlyArray<TOCItem>;
